import { IS_LOADING } from '@/store/types/root/actions-types';
import { GET_ACTIVITY_LOG_REQUEST } from './action-types';
import { ADD_ACTIVITY_LOG_TO_LIST } from "./mutation-types"
import api from "@/api/api"

export default {

    [GET_ACTIVITY_LOG_REQUEST]: async ({  commit })=>{
        let response = {}
        try {
            response =   await api.get("/rewards/stream")
            if(response.data.statusCode === 200){
                const reponseBody = response.data.body
                commit(ADD_ACTIVITY_LOG_TO_LIST, reponseBody)
            }
        } catch (err) {
            commit(IS_LOADING, false, { root: true })
        }
        return response
    },

}
